import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Carousel } from '../ui/Carousel';
const testimonials = [{
  quote: 'En tres semanas de aplicar las rutinas visuales y los bloques de tarea, mi hijo empezó a sentarse solo a estudiar. Algo que no había pasado en cuatro años. No lo podía creer.',
  author: 'Romina G.',
  location: 'Buenos Aires',
  details: 'Mamá de Mateo, 9 años, TDAH combinado'
}, {
  quote: 'La carta para el colegio me la bajé un martes, la mandé el miércoles y el viernes ya tenía una reunión con la directora. Nunca nadie me había explicado que tenía derechos reales y exigibles.',
  author: 'Marcela T.',
  location: 'Rosario',
  details: 'Mamá de Joaquín, 11 años, TDAH inatento'
}, {
  quote: 'Lo que más me cambió fue el tomo de las crisis. Ahora sé exactamente qué hacer cuando explota — y lo más importante: sé qué NO decir. Las peleas bajaron un 80% en menos de un mes.',
  author: 'Luciana P.',
  location: 'Córdoba',
  details: 'Mamá de Sofía, 8 años, TDAH con desregulación emocional'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 bg-white overflow-hidden" data-id="element-257">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <Carousel itemWidthClass="w-[85%] sm:w-[360px]" ariaLabel="Testimonios de familias" data-id="element-259">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -4
        }} className="bg-[#FBF7F0] p-6 md:p-8 rounded-2xl shadow-sm border border-[#1E2A4A]/5 flex flex-col w-full" data-id="element-260">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-261">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-yellow-400 text-yellow-400 md:w-5 md:h-5" data-id="element-262" />)}
              </div>
              <p className="text-[#1E2A4A] text-base md:text-lg italic mb-4 md:mb-6 flex-grow" data-id="element-263">
                "{t.quote}"
              </p>
              <div data-id="element-264">
                <p className="font-bold text-[#1E2A4A] text-sm md:text-base" data-id="element-265">
                  {t.author} — {t.location}
                </p>
                <p className="text-xs md:text-sm text-[#1E2A4A]/70 mt-1" data-id="element-266">
                  {t.details}
                </p>
              </div>
            </motion.div>)}
        </Carousel>
      </div>
    </section>;
}